import {Directive, HostBinding, Input, OnInit} from '@angular/core';

@Directive({
    selector: '[appTooltip]',
    standalone: true
})
export class TooltipDirective implements OnInit {
    @Input('appTooltip') tooltipText!: string; // Tooltip text
    @Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'right'; // Tooltip position

    @HostBinding('attr.pTooltip') pTooltip: string = '';
    @HostBinding('attr.tooltipPosition') tooltipPositionAttr: string = '';
    @HostBinding('attr.showDelay') showDelay: string = '600'; // Static delay

    ngOnInit(): void {
        this.pTooltip = this.tooltipText;
        this.tooltipPositionAttr = this.tooltipPosition;
    }
}
